import type { MaybeRefOrGetter } from 'vue';
import { unref } from 'vue';

export interface Params {
  city__slug?: MaybeRefOrGetter<string>;
  /**
   * slug страны
   */
  country__slug?: MaybeRefOrGetter<string>;
  /**
   * Тип экспириенса (group/private/ticket/tour/etc.)
   */
  exp_type?: MaybeRefOrGetter<string>;
  /**
   * Только длинные отзывы (длина >= 140 символов)
   */
  is_long?: MaybeRefOrGetter<1>;
  /**
   * Максимальное количество отзывов
   */
  limit?: MaybeRefOrGetter<number>;
  /**
   * Количество озывов в page
   */
  page_size?: MaybeRefOrGetter<number>;
  /**
   * Максимальная оценка
   */
  rate_max?: MaybeRefOrGetter<number>;
  /**
   * Минимальная оценка
   */
  rate_min?: MaybeRefOrGetter<number>;
  /**
   * slug региона
   */
  region__slug?: MaybeRefOrGetter<string>;
  /**
   * Отзывы только на экспириенсы в указанных рубриках (slug через запятую, экспириенс должен попадать во все указанные рубрики, а не в одну из)
   */
  tag__slug?: MaybeRefOrGetter<string>;
}

export const normalizeParams = (params: Params) => {
  return {
    city__slug: params?.city__slug ? (unref(params?.city__slug) as string) : undefined,
    country__slug: params?.country__slug ? (unref(params?.country__slug) as string) : undefined,
    exp_type: params?.exp_type ? (unref(params?.exp_type) as string) : undefined,
    is_long: params?.is_long ? (unref(params?.is_long) as 1) : undefined,
    limit: params?.limit ? (unref(params?.limit) as number) : undefined,
    page_size: params?.page_size ? (unref(params?.page_size) as number) : undefined,
    rate_max: params?.rate_max ? (unref(params?.rate_max) as number) : undefined,
    rate_min: params?.rate_min ? (unref(params?.rate_min) as number) : undefined,
    region__slug: params?.region__slug ? (unref(params?.region__slug) as string) : undefined,
    tag__slug: params?.tag__slug ? (unref(params?.tag__slug) as string) : undefined,
  };
};
